import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmHearingVO {
  id?: number
  caseId: number
  caseTitle?: string
  firmCaseNo?: string
  hearingTime: string
  location?: string
  courtRoom?: string
  judgeName?: string
  result?: string
  status?: string
  remark?: string
}

export interface FirmHearingPageReq extends PageParam {
  caseId?: number
  status?: string
}

export const FirmHearingApi = {
  create: (data: FirmHearingVO) => request.post({ url: '/lawyer/firm/hearing/create', data }),
  update: (data: FirmHearingVO) => request.put({ url: '/lawyer/firm/hearing/update', data }),
  delete: (id: number) => request.delete({ url: '/lawyer/firm/hearing/delete?id=' + id }),
  get: (id: number) => request.get({ url: '/lawyer/firm/hearing/get?id=' + id }),
  page: (params: FirmHearingPageReq) =>
    request.get<PageResult<FirmHearingVO>>({ url: '/lawyer/firm/hearing/page', params }),
  complete: (data: { id: number; result?: string }) =>
    request.put({ url: '/lawyer/firm/hearing/complete', data }),
  cancel: (id: number) => request.put({ url: '/lawyer/firm/hearing/cancel?id=' + id })
}
